export default __webpack_public_path__ + "static/share-7b60738222ca9ca07df8f523345996ea.png";